module.exports = __webpack_public_path__ + "static/media/Alaeddin.a26f5a61.jpeg";